import debounce from 'debounce'

document.addEventListener('DOMContentLoaded', () => {
	const map = document.querySelector('body.service-template #map');

	if (map) {
		const mapEl = document.getElementById('map')
		if (mapEl) {
			window.addEventListener('load', initMap)
		}

		function initMap() {
			const markers = _mapMarkers
			markers.forEach(marker => {
				let markerObj = {
					lat: parseFloat(marker.latitude),
					lng: parseFloat(marker.longitude),
				}
				marker['markerObj'] = markerObj
			})

			// Find center of multiple markers
			function findCenter(markers) {
				if (markers.length <= 1) {
					return markers[0].markerObj
				}
				const lats = markers.map(m => m.markerObj.lat)
				const lngs = markers.map(m => m.markerObj.lng)
				return {
					lat: (Math.min(...lats) + Math.max(...lats)) / 2,
					lng: (Math.min(...lngs) + Math.max(...lngs)) / 2,
				}
			}
			const centerPosition = findCenter(markers)

			var bounds = new google.maps.LatLngBounds()
			markers?.forEach(m => {
				bounds.extend(new google.maps.LatLng(m.markerObj.lat, m.markerObj.lng))
			})

			let zoomLevel
			if (window.innerWidth >= 1200) {
				zoomLevel = 15
			} else if (window.innerWidth >= 992) {
				zoomLevel = 14
			} else {
				zoomLevel = 13
			}

			const map = new google.maps.Map(document.getElementById('map'), {
				center: centerPosition,
				zoom: zoomLevel,
				mapId: '6e84f51d7043fec4',
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
			})

			let infoWindows = [];
			for (let i = 0; i < markers.length; i++) {
				let m = markers[i]
				const contentString =
					`<div class="tooltip-content">
						<p class="xs eyebrow org-name">${m.org_name}</p>
						<p class="location-name"><strong>${m.location_name}</strong></p>
						<p class="sm"><a href="https://www.google.com/maps?output=search&q=${m.address_link}" target="_blank">${m.address_string}</a></p>
					</div>`

				const infowindow = new google.maps.InfoWindow({
					content: contentString,
				})
				infoWindows.push(infowindow);

				let mrkr = new google.maps.Marker({
					position: m.markerObj,
					map,
					label: {
						text: m.label,
						color: 'white'
					},
				})

				mrkr.addListener('mouseover', () => {
					// This closes all open infowindows so only one can be open at a time
					infoWindows.forEach(infowindow => {
						infowindow.close()
					})

					infowindow.open({
						anchor: mrkr,
						map,
						shouldFocus: false,
					})
				})
			}

			const refreshCenter = debounce(() => {
				map.setCenter(centerPosition)

				var center = map.getCenter()
				var centerPoint = map.getProjection().fromLatLngToPoint(center)
				map.setCenter(map.getProjection().fromPointToLatLng(centerPoint))
			}, 100)

			const refreshBounds = () => {
				if (markers.length > 1) {
					map.fitBounds(bounds, 70);
				}
			}

			map.addListener('projection_changed', () => {
				refreshBounds()
				refreshCenter()
			})

			window.addEventListener('resize', () => {
				refreshBounds()
				refreshCenter()
			})

			google.maps.event.addListenerOnce(map, 'idle', () => {
				refreshBounds()
				refreshCenter()
			})
		}
	}
})
